import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import { Box, CircularProgress, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { Block, CheckCircle, Refresh } from "@mui/icons-material";
import { useNavigate } from "react-router";
import interactionPlugin from "@fullcalendar/interaction";
import { getElements, getReserves, updateElement } from "../../../database/API";
import Page from "../../../components/layouts/Page";
import DialogChangeBlock from "./DialogChangeBlock";
import { diaBlock } from "../../../utils";
import DialogAddReserva from "./DialogAddReserva";
import { useSnackbar } from "notistack";

function CalendariAdmin() {
    const matches = useMediaQuery("(min-width:960px)");
    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [filteredReserves, setFilteredReserves] = useState([]);
    const [dateSel, setDateSel] = useState();
    const [update, setUpdate] = useState(0);
    const [openChange, setOpenChange] = useState(false);
    const [dataBlock, setDataBlock] = useState([]);
    const [openAdd, setOpenAdd] = useState(false);
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        const obtenir = async () => {
            setLoading(true);
            let events = [];
            const { result } = await getReserves();
            const data_block = await getElements("data_block");
            setDataBlock(data_block?.result);

            await result.map((item) =>
                events.push({
                    title: item?.total + "px - " + item?.activitat?.nom.replace(/ .*/, "") + " - " + item?.nom + " " + item?.cognoms,
                    start: moment(item?.data).format("YYYY-MM-DD"),
                    end: moment(item?.data).add(1, "day"),
                    color: Number(item?.activitat?.id) === 2 ? "#9F371F" : "#d1a526",
                    id: item?.id,
                    activitat_id: item?.activitat_id,
                })
            );

            setTimeout(() => {
                setFilteredReserves(events);
                setLoading(false);
            }, 1000);
        };
        obtenir();
    }, [update]);

    function onClickEvent(e) {
        if (e.event.overlap === "block") {
            // setOpenChange(true);
            // setRestriccio(e.event);
        } else {
            navigate("/admin/reserves/" + e.event.id);
        }
    }

    function dateClick(e) {
        console.log(e["dateStr"]);
        setDateSel(e["dateStr"]);
        setOpenChange(true);
    }

    const renderDayContent = (day) => {
        let block = false;
        let icon = "";

        if (diaBlock(dataBlock, moment(day.date).format("YYYY-MM-DD"), moment(day.date).weekday() === 0 || moment(day.date).weekday() === 6)) {
            icon = <Block className={classes.iconCalendar} style={{ color: "red" }} />;
        } else {
            block = true;
            icon = <CheckCircle className={classes.iconCalendar} style={{ color: "green" }} />;
        }

        return (
            <Tooltip title={!block ? "Bloquejat" : "Disponible"}>
                <Box>
                    <Box zIndex={10}>
                        <Typography fontSize={14}>{day.dayNumberText}</Typography>
                    </Box>
                    {icon}
                </Box>
            </Tooltip>
        );
    };

    const handleEvent = async (event) => {
        console.log("JKJL", event.event.id, event.event.startStr);
        // setLoading(true);
        try {
            await updateElement("reserves", { data: event.event.startStr }, event.event.id);
            enqueueSnackbar("Actualitzat", {
                variant: "success",
            });
        } catch (error) {
            console.log(error);
            enqueueSnackbar("Error: Alguna cosa no ha anat bé", {
                variant: "error",
            });
            setUpdate((prev) => prev + 1);
        }
        // setLoading(false);
    };

    return (
        <Page title="Calendari">
            <div className={classes.calendar}>
                {loading && (
                    <Box className={classes.loading}>
                        <CircularProgress />
                    </Box>
                )}
                <FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    headerToolbar={{
                        left: matches ? "prev,next today" : "prev,next",
                        center: "title",
                        right: matches ? "dayGridMonth,timeGridWeek,timeGridDay refresh afegir" : "dayGridMonth,timeGridWeek,timeGridDay",
                    }}
                    initialView={matches ? "dayGridMonth" : "timeGridDay"}
                    events={filteredReserves}
                    eventOrder={"-activitat_id"}
                    locale={"ca"}
                    firstDay={1}
                    buttonText={{
                        today: "avui",
                        month: "mes",
                        week: "setmana",
                        day: "dia",
                    }}
                    allDayText="Tot el dia"
                    slotMinTime={"11:00"}
                    slotMaxTime={"16:00"}
                    editable={true}
                    height={window.innerHeight - 120}
                    eventTimeFormat={{
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: false,
                    }}
                    eventClick={onClickEvent}
                    eventDrop={handleEvent}
                    dateClick={dateClick}
                    dayCellContent={renderDayContent}
                    dayMaxEvents={5}
                    themeSystem="bootstrap"
                    customButtons={{
                        refresh: {
                            text: "Refrescar",
                            click: () => {
                                setUpdate((prev) => prev + 1);
                            },
                        },
                        afegir: {
                            text: "Afegir Reserva",
                            click: () => {
                                setOpenAdd(true);
                            },
                        },
                    }}
                />
            </div>
            <DialogChangeBlock
                dataBlock={dataBlock}
                open={openChange}
                setOpen={setOpenChange}
                loading={loading}
                data={dateSel}
                setLoading={setLoading}
                setUpdate={setUpdate}
            />
            <DialogAddReserva open={openAdd} setOpen={setOpenAdd} setUpdate={setUpdate} />
        </Page>
    );
}

export default CalendariAdmin;

const useStyles = makeStyles((theme) => ({
    calendar: {
        fontFamily: "Londrina Solid",
        color: theme.palette.text.primary,

        padding: 30,
        "& .fc-button-primary": {
            backgroundColor: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: theme.palette.primary.hover,
            },
            "&:focus": {
                boxShadow: "none",
            },
        },
        "& .fc-button-active": {
            backgroundColor: "#9F371F !important",
            borderColor: "#9F371F !important",
            "&:hover": {
                backgroundColor: theme.palette.primary.hover,
                borderColor: "#9F371F",
            },
        },
        "& td": {
            borderColor: "#9b9b9b",
            cursor: "pointer",
        },
        "& .fc-scrollgrid": {
            borderColor: "#9b9b9b",
        },
        "& th": {
            borderColor: "#9b9b9b",
        },
        "& a": {},
        "& .fc-daygrid-dot-event": {
            padding: 0,
            margin: 0,
            height: 17,
        },
        "& .fc-daygrid-event": {
            fontFamily: "Azeret Mono",
            fontSize: 12,
            padding: 0,
            margin: 0,
            height: 20,
            marginBottom: 5,
            [theme.breakpoints.down("sm")]: {
                height: 15,
                fontSize: 9,
            },
        },
        "& .fc-timegrid-event": {
            boxShadow: "none",
        },
        [theme.breakpoints.down("sm")]: {
            position: "relative",
            paddingTop: 40,
            "& .fc-toolbar-title": {
                position: "absolute",
                top: -5,
                left: 0,
            },
        },
    },
    iconCalendar: {
        position: "absolute",
        top: 8,
        right: 30,
        width: 20,
        height: 20,
        [theme.breakpoints.down("sm")]: {
            right: 25,
            width: 15,
            height: 15,
        },
    },
    iconCalendarRes: {
        position: "absolute",
        top: 0,
        right: 45,
    },
    loading: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1000,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
}));
